import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/panel`;

export const projectMap = {
  'app.projectMap':     (pId=':projectId') =>  `${prefix}/projects/${pId}/map`
}
